<template>
  <div class="flex items-center justify-center" :class="classes">
    <ul
      :class="[
        'flex items-center justify-center space-x-4 transform',
        direction,
      ]"
    >
      <li v-for="player in playerList" :key="player.user_id">
        <player-card
          :player="player"
          :direction="direction"
          :roomStateFinished="roomStateFinished"
          :timerCount="timerCount"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import PlayerCard from "../../Components/PlayerCard/PlayerCard";

export default {
  props: {
    direction: String,
    playerList: Array,
    roomStateFinished: Boolean,
    classes: String,
    timerCount: Number,
  },
  data() {
    return {
      person: {
        name: "asd",
        imageUrl: "/images/card-bg.svg",
      },
    };
  },
  components: {
    PlayerCard,
  },
};
</script>
